import InvestorInvitationApi from "api/wenImmo/InvestorInvitationApi";
import InvestorInvitationCreateRequestResource from "common/resources/InvestorInvitation/InvestorInvitationCreateRequestResource";
import InvestorInvitationLinkResponseResource from "common/resources/InvestorInvitation/InvestorInvitationLinkResponseResource";
import InvestorInvitationLinkValueResponseResource from "common/resources/InvestorInvitation/InvestorInvitationLinkValueResponseResource";
import InvestorInvitationProductResponseResource from "common/resources/InvestorInvitation/InvestorInvitationProductResponseResource";
import InvestorInvitationResponseResource from "common/resources/InvestorInvitation/InvestorInvitationResponseResource";
import { container, singleton } from "tsyringe";
import toValidationError from "utils/toValidationError";

@singleton()
export default class InvestorInvitationService {
	private readonly api = container.resolve(InvestorInvitationApi);

	public async getAll(): Promise<InvestorInvitationResponseResource[]> {
		return this.api
			.getAll()
			.then((invitations) => InvestorInvitationResponseResource.hydrateArray<InvestorInvitationResponseResource>(invitations))
			.catch(toValidationError);
	}

	/** Produits du cabinet ouverts au portail investisseur. */
	public async getProducts(): Promise<InvestorInvitationProductResponseResource[]> {
		return this.api
			.getProducts()
			.then((products) => InvestorInvitationProductResponseResource.hydrateArray<InvestorInvitationProductResponseResource>(products))
			.catch(toValidationError);
	}

	/** Lien d'une invitation dont `isLinkAvailable` est vrai, pour le recopier : avant comme après l'envoi du dossier. */
	public async getLink(id: string): Promise<string> {
		return this.api
			.getLink(id)
			.then((response) => InvestorInvitationLinkValueResponseResource.hydrate<InvestorInvitationLinkValueResponseResource>(response).link)
			.catch(toValidationError);
	}

	/** Renvoie le lien à transmettre au client. */
	public async create(resource: InvestorInvitationCreateRequestResource): Promise<InvestorInvitationLinkResponseResource> {
		return this.api
			.create(resource)
			.then((response) => InvestorInvitationLinkResponseResource.hydrate<InvestorInvitationLinkResponseResource>(response))
			.catch(toValidationError);
	}

	/** Crée un nouveau lien : le précédent cesse de fonctionner. */
	public async resend(id: string): Promise<InvestorInvitationLinkResponseResource> {
		return this.api
			.resend(id)
			.then((response) => InvestorInvitationLinkResponseResource.hydrate<InvestorInvitationLinkResponseResource>(response))
			.catch(toValidationError);
	}

	public async revoke(id: string): Promise<InvestorInvitationResponseResource> {
		return this.api
			.revoke(id)
			.then((invitation) => InvestorInvitationResponseResource.hydrate<InvestorInvitationResponseResource>(invitation))
			.catch(toValidationError);
	}
}
